import React, { Component, useState, useEffect } from "react";
import logo from "./logo.PNG";
import croppedlogo from './croppedlogo.png'
import "../../dist/assets/stylesheets/css/navbar.css";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useHistory } from 'react-router-dom'
import { usePipelineVersion } from "../hooks/usePipelineVersion";
import { isCalibrationUiEnabled } from "../util/pipelineVersion";
import { useLegacyAvailability } from "../hooks/useLegacyAvailability";

const SIDEBAR_COLLAPSED_KEY = "sidebarCollapsed";

function readSidebarCollapsed() {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
  } catch (err) {
    return false;
  }
}

function writeSidebarCollapsed(collapsed) {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? "true" : "false");
  } catch (err) {
    // A full quota or private-mode storage should not block the toggle.
  }
}

function Navbar() {
  const history = useHistory()
  const [collapsed, setCollapsed] = useState(readSidebarCollapsed);
  const calibrationEnabled = isCalibrationUiEnabled(usePipelineVersion());
  const legacyAvailable = useLegacyAvailability();
  const [evowalkIntegrationEnabled, setEvowalkIntegrationEnabled] = useState(() => {
    return localStorage.getItem('evowalkIntegrationEnabled') === 'true';
  });

  useEffect(() => {
    const handleEvoWalkToggle = () => {
      setEvowalkIntegrationEnabled(localStorage.getItem('evowalkIntegrationEnabled') === 'true');
    };
    
    window.addEventListener('evoWalkToggle', handleEvoWalkToggle);
    
    return () => {
      window.removeEventListener('evoWalkToggle', handleEvoWalkToggle);
    };
  }, []);

  const logOut = () => {
    localStorage.removeItem('token')
    history.push('/')
  }
  const isActive = (path_name) => {
    let window_url = window.location.href
    if (window_url.includes(path_name))
      return true
    return false
  }

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      writeSidebarCollapsed(next);
      return next;
    });
    // After the sidebar width/margin transition (~200ms) completes,
    // trigger a window resize so CanvasJS and other listeners can
    // recompute layout once, avoiding mid-animation glitches.
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 220);
  };

  return (
    <div className={`navbar ${collapsed ? "collapsed" : ""}`}>
      <button
        type="button"
        className="navbar-collapse-toggle"
        onClick={toggleCollapsed}
        aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {collapsed ? (
          <Icon icon="mdi:chevron-double-right" className="navbar-collapse-icon" />
        ) : (
          <Icon icon="mdi:chevron-double-left" className="navbar-collapse-icon" />
        )}
      </button>
      <div className="navbar-logo" style={{ display: 'flex', 'justify-content': 'center' }}>
        <img
          src={collapsed ? croppedlogo : logo}
          alt="EvoVision"
          className="navbar-logo-img"
          style={collapsed ? { width: 32, height: 32 } : { width: "180px", height: "60px", marginBottom: "0px" }}
        />
      </div>
      <div className="menu">
        <div className="menu-spacer" aria-hidden="true" />
        <div className="menu-links">
          <Link to="/devices" className={isActive("/devices") && "active"}>
            <Icon icon="ph:camera-light" />
            <span>Cameras</span>
          </Link>
          {evowalkIntegrationEnabled && (
            <Link to="/evowalk" className={isActive("/evowalk") && "active"}>
              <Icon icon="mdi:walk" />
              <span>EvoWalk<sup>™</sup></span>
            </Link>
          )}
          {calibrationEnabled && (
            <Link to="/calibration" className={isActive("/calibration") && "active"}>
              <Icon icon="bxs:chess" />
              <span>Calibration</span>
            </Link>
          )}
          <Link to="/record-test" className={isActive("/record-test") && "active"}>
            <Icon icon="ph:video-camera" />
            <span>Record</span>
          </Link>
          <Link to="/recordings" className={isActive("/recordings") && "active"}>
            <Icon icon="ph:video-thin" />
            <span>Recordings</span>
          </Link>
          <Link to="/patients" className={isActive("/patients") && "active"}>
            <Icon icon="fluent:people-team-28-regular" />
            <span>Analytics</span>
          </Link>
          {legacyAvailable && (
            <Link to="/legacy" className={isActive("#/legacy") && "active"}>
              <Icon icon="mdi:archive-outline" />
              <span>Legacy analytics</span>
            </Link>
          )}
        </div>
        <div className="menu-spacer" aria-hidden="true" />
        <div className="menu-bottom">
          <hr />
          <Link to="/account" className={isActive("/account") && "active"}>
            <Icon icon="codicon:account" />
            <span>Account</span>
          </Link>
          <a id="logout-btn" onClick={logOut}>
            <Icon icon="ph:sign-out" />
            <span>Log out</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
